export default "__VITE_PUBLIC_ASSET__8f9e8c3a__"